import React from "react";
import {
  Route,
  Redirect,
  Switch,
  useLocation,
  HashRouter
} from "react-router-dom";
import PropTypes from "prop-types";
import LoginAdmin from "../login/Login";
import PublicRoute from "../Routes/PublicRoute"
import PrivateRoute from "../Routes/PrivateRoute"
import Empresas from "../empresas/Empresas"
import tipoDocumento from "../tiposDocumento/TiposDocumentos"
import numeroPatronal from "../numeroPatronal/NumerosPatronales"
import aplicacionExterna from "../aplicacionExterna/AplicacionesExterna"
import usuarios from "../usuario/Usuarios"
import configuracion from "../correo/Configuracion"
import plantillaCorreo from "../correo/PlantillaCorreo"
import lotesNuevos from "../lotes/LotesNuevos"
import lotesFirmados from "../lotes/LotesFirmados"
import lotesPublicar from "../lotes/LotesPublicar"
import lotesPublicados from "../lotes/LotesPublicados"
import lotesCerrados from "../lotes/LotesCerrados"
import recibosPendientes from "../recibos/RecibosPendientes"
import recibosConfirmados from "../recibos/RecibosConfirmados"
import recibosFirmados from "../recibos/RecibosFirmados"
import recibosRechazados from "../recibos/RecibosRechazados"
import reportesEmpleados from "../reportes/ReportesEmpleados"
import reporteRecibos from "../reportes/ReporteRecibos"
import ImportarDocumento from "../lotes/ImportarDocumento";
import recibos from "../recibos/Recibos"
import { connect } from 'react-redux';
import axios from "axios";
import { authenticateLoginCliente, logged, loggedAux, obtenerURL } from '../login/SesionService'
import {
  URL, logueado, administradorEmpresas, gestorEmpresa, empleado, gestionTramites, estructuraOrganizacional,
  iscertLoguin, firmaRL, firmaRRHH, reportes,
  gestionNotificacion, gestionLegajos
} from '../../constans/constants';
import pdfVisor from '../documentViewer/VistaPdf'
import NuevoTipoDocumento from "../tiposDocumento/NuevoTipoDocumento";
import reciboEmpleado from "../recibos/ReciboEmpleado"
import reportesFirmados from "../reportes/ReportesFirmados"
import reportesRechazados from "../reportes/ReportesRechazados"
import reportesPendientes from "../reportes/ReportesPendientes"
import VistaPdf from "../documentViewer/VistaPdf";
import { logout } from "../login/SesionService";
import ReportesConfirmados from "../reportes/ReportesConfirmados";
import superAdminForm from "../home/SuperAdmin"
import GruposUsuarios from "../usuario/GruposUsuarios";
import proveedoresFirma from "../pca/ProveedoresFirma";
import ActualizarContrasenha from "../usuario/ActualizarPasswrd";
import Organizacion from "../organizacion/Organizacion";
import ConfiguracionApp from "../configuracion/ConfiguracionApp";
import TramitesPendientes from "../tramites/TramitesPendientes";
import TramitesFirmados from "../tramites/TramitesFirmados";
import FirmarTramite from "../tramites/FirmarTramite";
import VistaTramitePDF from "../tramites/VistaTramitePDF";
import BandejaTramitesPendientes from "../tramites/BandejaTramitesPendientes";
import BandejaTramitesFirmados from "../tramites/BandejaTramitesFirmados";
import BandejaTramitesRechazados from "../tramites/BandejaTramitesRechazados";
import TramitesCerrados from "../tramites/TramitesCerrados";
import TramitesRechazados from "../tramites/TramitesRechazados";
import ErrorPage from "../errors/ErrorPage";
import LoginKeicloack from "../login/LoginKeicloack";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import NuevoLote from "../lotes/NuevoLote";
import ImportarLote from "../lotes/ImportarLote";

import AvisoImportDocumento from "../componentes/avisos/AvisoImportDocumento";

import NuevoTramite from "../tramites/NuevoTramite";
import ImportarDocumentoGrupos from "../lotes/ImportarDocumentoGrupos";
import TiposTramites from "../tramites/TiposTramites";
import SeleccionPlantillas from "../correo/SeleccionPlantillas";
import PlantillaCorreo from "../correo/PlantillaCorreo";
import AplicacionExterna from "../aplicacionExterna/AplicacionExterna";
import NumeroPatronal from "../numeroPatronal/NumeroPatronal";
import AvisoCreacionTipoDocumento from "../componentes/avisos/AvisoCreacionTipoDocumento";
import Unidad from "../organizacion/Unidad";
import DatosUsuarioModal from "../usuario/DatosUsuarioModal";
import Usuario from "../usuario/Usuario";
import ImportarUsuarios from "../usuario/ImportarUsuarios";
import AvisoImportUsuario from "../componentes/avisos/AvisoImportUsuario";
import Miembro from "../organizacion/Miembro";
import NuevoTipoTramite from "../tramites/NuevoTipoTramite";
import AvisoDocumentoFirmado from "../componentes/avisos/AvisoDocumentoFirmado";
import AvisoImportLote from "../componentes/avisos/AvisoImportLote";
import GrupoUsuario from "../usuario/GrupoUsuario";
import Empresa from "../empresas/Empresa";
import ProveedorFirma from "../pca/ProveedorFirma";
import Notificaciones from "../notificacion/Notificaciones";
import NoLeidas from "../notificacion/NoLeidas";
import Leidas from "../notificacion/Leidas";
import Notificacion from "../notificacion/Notificacion";
import Borradores from "../notificacion/Borradores";
import Enviadas from "../notificacion/Enviadas";
import { BlockedRedirectAlert } from '../../components/seguridad/SafeRedirectComponent';
import Feriados from "../feriado/Feriados";
import Feriado from "../feriado/Feriado";
import Legajos from "../componentes/legajo/Legajos";
import EditarLegajo from "../componentes/legajo/EditarLegajo";
import VerLegajo from "../componentes/legajo/VerLegajo";
import Vacaciones from "../vacaciones/Vacaciones";
import AsignarVacaciones from "../vacaciones/AsignarVacaciones";
import VerVacaciones from "../vacaciones/VerVacaciones";
export function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(window.location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

function Home(props) {
  const location = useLocation();
  const [mensajeAlerta, setMensajeAlerta] = React.useState("");
  const [severity, setSeverity] = React.useState("exito");
  const [mensajeOpen, setMensajeOpen] = React.useState(false);
  const redirectURLFirma = localStorage.getItem("redirectURLFirma");

  React.useEffect(() => {
    const kcActionStatus = getParameterByName('kc_action_status');
    if (kcActionStatus !== "") {
      if (kcActionStatus === "success") {
        setMensajeAlerta("Contraseña modificada con éxito");
        setSeverity("exito");
        setMensajeOpen(true);
      } else if (kcActionStatus !== "cancelled") {
        setMensajeAlerta("Se produjo un error al intentar modificar la contraseña");
        setSeverity("error");
        setMensajeOpen(true);
      }
      window.history.pushState('', '', '/mirecibo/#');
    }
  }, []);

  if (iscertLoguin) {
    if (!logueado() && location.pathname != '/admin/login') {
      if (getParameterByName('token') === "") {
        axios.get(URL + "auth").then((res) => {
          window.location.replace(res.data);
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        });
      } else if (!logueado()) {
        const token = getParameterByName('token');
        const username = getParameterByName('username');
        const admin = false;
        props.authenticateLoginCliente({
          token: token,
          username: username,
          admin: admin
        });
        //window.history.pushState('', '', '/#')
        window.history.pushState('', '', '/mirecibo/#')
      }
    }
  } else {
    if (getParameterByName('token') != "") {
      localStorage.setItem("tokenIscert", getParameterByName('token'))
      if (redirectURLFirma != null) {
        localStorage.removeItem("redirectURLFirma")
        //window.history.pushState('', '', '/' + redirectURLFirma)
        window.history.pushState('', '', '/mirecibo/' + redirectURLFirma)
      } else {
        //window.history.pushState('', '', '/#')
        window.history.pushState('', '', '/mirecibo/#')
      }
    }

    if (getParameterByName('status_tuid') != "") {
      localStorage.setItem("status_tuid", getParameterByName('status_tuid'))
      if (redirectURLFirma != null) {
        localStorage.removeItem("redirectURLFirma")
        //window.history.pushState('', '', '/' + redirectURLFirma)
        window.history.pushState('', '', '/mirecibo/' + redirectURLFirma)
      } else {
        //window.history.pushState('', '', '/#')
        window.history.pushState('', '', '/mirecibo/#')
      }
    }

  }

  return (
    <HashRouter basename="">
      <Switch>
        <PublicRoute restricted={true} path="/login" component={LoginKeicloack} />
        <PublicRoute restricted={true} path="/admin/login" component={LoginAdmin} />
        <PublicRoute restricted={true} path="/admin/registro" component={superAdminForm} />
        {!iscertLoguin && <Redirect exact from="/" to="/login" />}
        <Redirect exact from="/mirecibo" to="/recibos/pendientes" />
        <Redirect exact from="/" to="/recibos/pendientes" />
        <Route
          render={() => {
            if (location.pathname == '/error') {
              return (<ErrorPage />)
            } else
              return (
                <>
                  <MensajeFlash
                    visible={mensajeOpen}
                    mensaje={mensajeAlerta}
                    severity={severity}
                  />

                  <Switch>
                    <PrivateRoute path="/admin/empresas" component={Empresas} layout="admin" tituloSeccion="Empresas" exact />
                    <PrivateRoute path="/admin/empresas/:tipoAccion" component={Empresa} layout="admin" tituloSeccion="Empresas" exact />
                    <PrivateRoute path="/admin/configuracion/tipo-documento" component={tipoDocumento} exact />
                    <PrivateRoute path="/admin/configuracion/tipo-documento/nuevo" rol={[gestorEmpresa]} component={NuevoTipoDocumento} exact />
                    <PrivateRoute path="/admin/configuracion/numero-patronal" component={numeroPatronal} exact />
                    <PrivateRoute path="/admin/configuracion/aplicaciones-externas" component={aplicacionExterna} exact />
                    <PrivateRoute path="/admin/proveedores-firma" component={proveedoresFirma} layout="admin" tituloSeccion="Proveedores de Firma" exact />
                    <PrivateRoute path="/admin/proveedores-firma/accion/:tipoAccion" component={ProveedorFirma} layout="admin" tituloSeccion="Proveedores de Firma" exact />
                    <PrivateRoute path="/admin/usuarios" component={usuarios} layout="admin" tituloSeccion="Usuarios" exact />
                    <PrivateRoute path="/admin/usuarios/importar" component={ImportarUsuarios} layout="admin" tituloSeccion="Usuarios" exact />
                    <PrivateRoute path="/notificacion/configuracion-correo" component={configuracion} layout="admin" tituloSeccion="Configuración de Correo" exact />
                    <PrivateRoute path="/admin/notificacion/plantilla-correo" component={plantillaCorreo} exact />
                    <PrivateRoute path="/administracion/usuarios" rol={[administradorEmpresas]} component={usuarios} layout="none" exact />
                    <PrivateRoute path="/administracion/usuarios/importar" rol={[administradorEmpresas]} component={ImportarUsuarios} layout="none" exact />
                    <PrivateRoute path="/administracion/usuarios/importar/resultados" rol={[administradorEmpresas]} component={AvisoImportUsuario} layout="none" exact />
                    <PrivateRoute path="/administracion/usuarios/:tipoAccion" rol={[administradorEmpresas]} component={Usuario} layout="none" exact />
                    <PrivateRoute path="/administracion/usuarios/actualizar-password" component={ActualizarContrasenha} exact />
                    <PrivateRoute path="/administracion/grupos" rol={[administradorEmpresas]} component={GruposUsuarios} layout="none" exact />
                    <PrivateRoute path="/administracion/grupos/:tipoAccion" rol={[administradorEmpresas]} component={GrupoUsuario} layout="none" exact />
                    <PrivateRoute path="/administracion/legajos" rol={[gestionLegajos]} component={Legajos} layout="none" exact />
                    <PrivateRoute path="/administracion/legajo/ver/:id" rol={[gestionLegajos]} component={VerLegajo} layout="none" exact />
                    <PrivateRoute path="/administracion/legajo/editar/:id" rol={[gestionLegajos]} component={EditarLegajo} layout="none" exact />
                    <PrivateRoute path="/administracion/vacaciones" rol={[administradorEmpresas, gestionLegajos]} component={Vacaciones} layout="none" exact />
                    <PrivateRoute path="/administracion/vacaciones/asignar" rol={[administradorEmpresas, gestionLegajos]} component={AsignarVacaciones} layout="none" exact />
                    <PrivateRoute path="/administracion/vacaciones/legajo/:legajoId" rol={[administradorEmpresas, gestionLegajos]} component={VerVacaciones} layout="none" exact />
                    <PrivateRoute path="/configuracion/aplicaciones-externas" rol={[gestorEmpresa]} component={aplicacionExterna} layout="none" exact />
                    <PrivateRoute path="/configuracion/aplicaciones-externas/:tipoAccion" rol={[gestorEmpresa]} component={AplicacionExterna} layout="none" exact />

                    <PrivateRoute path="/configuracion/tipo-documento" rol={[gestorEmpresa]} component={tipoDocumento} layout="none" exact />
                    <PrivateRoute path="/configuracion/tipo-documento/:tipoAccion" rol={[gestorEmpresa]} component={NuevoTipoDocumento} layout="none" exact />
                    <PrivateRoute path="/configuracion/tipo-documento/:tipoAccion/:resultado" rol={[gestorEmpresa]} component={AvisoCreacionTipoDocumento} layout="none" exact />

                    <PrivateRoute path="/configuracion/tipo-solicitud" rol={[gestionTramites]} component={TiposTramites} layout="none" exact />
                    <PrivateRoute path="/configuracion/tipo-solicitud/:tipoAccion" rol={[gestionTramites]} component={NuevoTipoTramite} layout="none" exact />
                    <PrivateRoute path="/configuracion/numero-patronal" rol={[gestorEmpresa]} component={numeroPatronal} layout="none" exact />
                    <PrivateRoute path="/configuracion/numero-patronal/:tipoAccion" rol={[gestorEmpresa]} component={NumeroPatronal} layout="none" exact />

                    <PrivateRoute path="/mi-cuenta" rol={[empleado]} component={DatosUsuarioModal} layout="none" exact />

                    <PrivateRoute path="/lotes/generar" rol={[gestorEmpresa, firmaRRHH]} component={NuevoLote} layout="none" exact />
                    <PrivateRoute path="/lotes/generar/zip" rol={[gestorEmpresa, firmaRRHH]} component={ImportarLote} layout="none" exact />
                    <PrivateRoute path="/lotes/generar/documento" rol={[gestorEmpresa, firmaRRHH]} component={ImportarDocumento} layout="none" exact />
                    <PrivateRoute path="/lotes/generar/documento-grupos" rol={[gestorEmpresa, firmaRRHH]} component={ImportarDocumentoGrupos} layout="none" exact />

                    <PrivateRoute path="/lotes/importacion/:resultado" rol={[gestorEmpresa, firmaRRHH]} component={AvisoImportLote} layout="none" exact />

                    <PrivateRoute path="/lote/nuevos" rol={[gestorEmpresa, firmaRRHH]} component={lotesNuevos} exact />
                    <PrivateRoute path="/lote/firmados" rol={[gestorEmpresa, firmaRL]} component={lotesFirmados} exact />
                    <PrivateRoute path="/lote/publicar" rol={[gestorEmpresa]} component={lotesPublicar} exact />
                    <PrivateRoute path="/lote/publicados" rol={[gestorEmpresa]} component={lotesPublicados} exact />
                    <PrivateRoute path="/lote/cerrados" rol={[gestorEmpresa]} component={lotesCerrados} exact />
                    <PrivateRoute path="/lote/recibos/:estado/:idLote" rol={[gestorEmpresa, firmaRL, firmaRRHH]} component={recibos} layout="none" exact />
                    <PrivateRoute path="/lote/recibos/visor" component={pdfVisor} exact />
                    <PrivateRoute path="/admin/notificacion/configuracion-correo" component={configuracion} layout="admin" tituloSeccion="Configuración de Correo" exact />
                    <PrivateRoute path="/configuracion/plantilla-correo" rol={gestorEmpresa} component={SeleccionPlantillas} layout="none" exact />
                    <PrivateRoute path="/configuracion/plantilla-correo/editar" rol={gestorEmpresa} component={PlantillaCorreo} layout="none" exact />
                    <PrivateRoute path="/configuracion/tipo-documento/nuevo" rol={[gestorEmpresa, firmaRRHH]} component={NuevoTipoDocumento} layout="none" exact />
                     <PrivateRoute path="/configuracion/feriados" rol={gestorEmpresa} component={Feriados} layout="none" exact />
                     <PrivateRoute path="/configuracion/feriados/:tipoAccion" rol={[gestorEmpresa]} component={Feriado} layout="none" exact />

                    <PrivateRoute path="/estructura/organizacion" rol={estructuraOrganizacional} layout="none" component={Organizacion} exact />
                    <PrivateRoute path="/estructura/organizacion/editar-unidad" rol={estructuraOrganizacional} layout="none" component={Unidad} exact />
                    <PrivateRoute path="/estructura/organizacion/agregar-miembro" rol={estructuraOrganizacional} layout="none" component={Miembro} exact />

                    <PrivateRoute path="/tramites/generar" rol={gestionTramites} component={NuevoLote} layout="none" exact />
                    <PrivateRoute path="/tramites/nuevo" rol={gestionTramites} component={NuevoTramite} layout="none" exact />
                    <PrivateRoute path="/tramites/pendientes" rol={gestionTramites} component={TramitesPendientes} exact />
                    <PrivateRoute path="/tramites/firmados" rol={gestionTramites} component={TramitesFirmados} exact />
                    <PrivateRoute path="/tramites/cerrados" rol={gestionTramites} component={TramitesCerrados} exact />
                    <PrivateRoute path="/tramites/rechazados" rol={gestionTramites} component={TramitesRechazados} exact />
                    <PrivateRoute path="/tramites/firma/:ubicacion/:idTramite" rol={[gestionTramites]} component={FirmarTramite} layout="none" exact />      
                    <PrivateRoute path="/tramites/:nombre/:idTramite" rol={[gestionTramites]} component={VistaTramitePDF} layout="none" exact />

                    <PrivateRoute path="/bandeja/pendientes" rol={[empleado]} component={recibosPendientes} exact />
                    <PrivateRoute path="/bandeja/confirmados" rol={[empleado]} component={recibosConfirmados} exact />
                    <PrivateRoute path="/bandeja/firmados" rol={[empleado]} component={recibosFirmados} exact />
                    <PrivateRoute path="/bandeja/rechazados" rol={[empleado]} component={recibosRechazados} exact />

                    {/*<PrivateRoute path="/bandeja/tramite/pendientes" rol={[gestionTramites]} component={BandejaTramitesPendientes} exact />*/}
                    {/*<PrivateRoute path="/bandeja/tramite/firmados" rol={[gestionTramites]} component={BandejaTramitesFirmados} exact />*/}
                    {/*<PrivateRoute path="/bandeja/tramite/rechazados" rol={[gestionTramites]} component={BandejaTramitesRechazados} exact />*/}

                    <PrivateRoute path="/reporte/recibo-colaborador/todos" rol={[gestorEmpresa, reportes]} component={reportesEmpleados} exact />
                    <PrivateRoute path="/reporte/:colaborador/recibos/:id/estado/:estado" rol={[gestorEmpresa, reportes]} component={reporteRecibos} layout="none" exact />
                    <PrivateRoute path="/reporte/:colaborador/recibos/:id" rol={[gestorEmpresa, reportes]} component={reporteRecibos} layout="none" exact />
                    <PrivateRoute path="/reporte/recibo-colaborador/firmados" rol={[gestorEmpresa, reportes]} component={reportesFirmados} exact />
                    <PrivateRoute path="/reporte/recibo-colaborador/pendientes" rol={[gestorEmpresa, reportes]} component={reportesPendientes} exact />
                    <PrivateRoute path="/reporte/recibo-colaborador/rechazados" rol={[gestorEmpresa, reportes]} component={reportesRechazados} exact />
                    <PrivateRoute path="/reporte/recibo-colaborador/aceptados" rol={[gestorEmpresa, reportes]} component={ReportesConfirmados} exact />
                    <PrivateRoute path="/recibo/view/:estado/:idLote/:idRecibo" rol={[empleado]} component={reciboEmpleado} layout="none" exact />
                    <PrivateRoute path="/bandeja/recibo/view/:estado/:idLote/:idRecibo" rol={[empleado]} component={reciboEmpleado} layout="none" exact />
                    <PrivateRoute path="/recibo/:recibo/lote/:lote/ver" component={VistaPdf} layout="none" exact />
                    <PrivateRoute path="/reporte/nro-recibo/:recibo/nro-lote/:lote/ver" component={VistaPdf} layout="none" exact />
                    <PrivateRoute path="/bandeja/nro-recibo/:recibo/nro-lote/:lote/ver" component={VistaPdf} layout="none" exact />    
                    <PrivateRoute path="/:tipoDocumento/import/:resultado" component={AvisoImportDocumento} layout="none" exact />                              
                    <PrivateRoute path="/:tipoDocumento/:accion/:resultado" component={AvisoDocumentoFirmado} layout="none" exact />

                    <PrivateRoute path="/notificaciones/todos" component={Notificaciones} exact/>
                    <PrivateRoute path="/notificaciones/noleidas" component={NoLeidas} exact/>
                    <PrivateRoute path="/notificaciones/leidas" component={Leidas} exact/>
                    <PrivateRoute path="/notificaciones/crear-notificacion" component={Notificacion} layout="none" exact/>
                    <PrivateRoute path="/notificaciones/borradores" rol={[gestionNotificacion]} component={Borradores} exact/>
                    <PrivateRoute path="/notificaciones/emitidas" rol={[gestionNotificacion]} component={Enviadas} exact/>

                    <Route path="*" render={(props) => <ErrorPage {...props} isError={true} />} />
                  </Switch>
                </>

              );
          }}
        />
      </Switch>
    </HashRouter>
  );
}

Home.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  authenticateLoginCliente: (value) => dispatch(authenticateLoginCliente(value)),
  logged: () => dispatch(logged())
});
export default connect(null, mapDispatchToProps)(Home);
